import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';
import appReducer from './App.reducer';
import homeReducer from './home/Home.reducer';
import formReducer from './form/Form.reducer';
import offerReducer from './form/components/Offer/offer.reducer';
import toastsReducer from './toasts/toasts.reducer';
import settingsReducer from './settings/Settings.reducer';
import messagesReducer from './messages/Messages.reducer';
import lazyOpenReducer from './lazyOpen/LazyOpen.reducer';
import translationsReducer from './translations/translator.reducer';
import popupReducer from './popups/Popup.reducer';



const rootReducer = combineReducers({
    app: appReducer,
    home: homeReducer,
    form: combineReducers({
        base: formReducer,
        offer: offerReducer
    }),
    toasts: toastsReducer,
    settings: settingsReducer,
    messages: messagesReducer,
    oidc: oidcReducer,
    lazyOpen: lazyOpenReducer,
    translations: translationsReducer,
    popups: popupReducer,
});
export default rootReducer;
